<template>
    <div>
        <svg v-if="hasCircle" xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48" fill="none">
            <path
                d="M24 43.9993C35.0457 43.9993 44 35.045 44 23.9993C44 12.9536 35.0457 3.99927 24 3.99927C12.9543 3.99927 4 12.9536 4 23.9993C4 35.045 12.9543 43.9993 24 43.9993Z"
                :stroke="circleColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M16.8 17H31.2C32.19 17 33 17.7875 33 18.75V29.25C33 30.2125 32.19 31 31.2 31H16.8C15.81 31 15 30.2125 15 29.25V18.75C15 17.7875 15.81 17 16.8 17Z"
                :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M33 19L24 25L15 19" :stroke="color" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <svg :width="size" :height="size" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
            <path
            d="M2.66634 2.66663H13.333C14.0663 2.66663 14.6663 3.26663 14.6663 3.99996V12C14.6663 12.7333 14.0663 13.3333 13.333 13.3333H2.66634C1.93301 13.3333 1.33301 12.7333 1.33301 12V3.99996C1.33301 3.26663 1.93301 2.66663 2.66634 2.66663Z"
            :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M14.6663 4L7.99967 8.66667L1.33301 4" :stroke="color" stroke-width="1.5" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
    </div>
</template>

<script>
export default {
    props: {
        size: {
            type: String,
            default: '48'
        },
        color: {
            type: String,
            default: '#3D5DFC',
            required: false
        },
        circleColor: {
            type: String,
            default: '#CAD3FF',
            required: false
        },
        hasCircle: {
            type: Boolean,
            default: true,
            required: false
        }
    },
}
</script>

<style>
</style>